import env from '@/env';
import cookie from '@/helpers/cookie';

const COOKIE_ACCEPTED = 'accepted';
const COOKIE_NAME = 'PrivacyStatement';

export default {
  data() {
    return {
      hidden: false,
    };
  },
  computed: {
    show() {
      return env.PRIVACY_STATEMENT_ENABLED && cookie.get(COOKIE_NAME) === null && !this.hidden;
    },
  },
  methods: {
    onAgree() {
      cookie.setForever({ [COOKIE_NAME]: COOKIE_ACCEPTED });
      this.onHide();
    },
    onHide() {
      this.hidden = true;
    },
  },
};
